import RestApiModel from "@/api/Model/RestApiModel";

class ReferralList extends RestApiModel {
  static getResourceEndpoint() {
    return '/ReferralList';
  }
}

export default ReferralList;
